export default __webpack_public_path__ + "static/media/theme.d4604caa.mp3";